import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Tooltip,
  Box,
} from '@chakra-ui/react'
import { QuestionOutlineIcon } from '@chakra-ui/icons'
import PhoneInputComponent from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import './PhoneInputStyles.css'

interface PhoneInputProps {
  label: string
  placeholder?: string
  helpText?: string
  isInvalid?: boolean
  errorMessage?: string
  value?: string
  onChange?: (value: string | undefined) => void
}

export default function PhoneInput({
  label,
  placeholder,
  helpText,
  isInvalid,
  errorMessage,
  value = '',
  onChange,
}: PhoneInputProps) {
  return (
    <FormControl isInvalid={isInvalid}>
      <FormLabel display="flex" alignItems="center" gap={2} fontSize="sm" fontWeight="medium">
        {label}
        {helpText && (
          <Tooltip label={helpText} fontSize="sm" placement="right" hasArrow>
            <QuestionOutlineIcon color="gray.400" boxSize={3.5} cursor="help" />
          </Tooltip>
        )}
      </FormLabel>
      <Box className="phone-input-wrapper">
        <PhoneInputComponent
          international
          defaultCountry="FR"
          countryCallingCodeEditable={false}
          placeholder={placeholder || 'e.g. +33 6 12 34 56 78'}
          value={value}
          onChange={(val) => onChange?.(val as string | undefined)}
          className={isInvalid ? 'phone-input-invalid' : ''}
        />
      </Box>
      {isInvalid && errorMessage && (
        <FormErrorMessage fontSize="sm">{errorMessage}</FormErrorMessage>
      )}
    </FormControl>
  )
}
